module.exports = __webpack_public_path__ + "static/media/iap-split-green.22c14183.png";